/**
 * @file Web Gallery discovery container.
 */

import compose from 'lodash.flowright';
import { withApollo } from 'react-apollo';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import WebGalleryDiscovery from '../components/WebGalleryDiscovery';
import { openModal } from '../../../actions/modal-actions';

const mapStateToProps = ({ auth }) => ({
  authenticated: auth.authenticated,
});

const mapDispatchToProps = {
  openModal,
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withRouter,
  withApollo,
)(WebGalleryDiscovery);
